import { useAtomValue } from "jotai";
import { Group, Line } from "react-konva";
import { zoomAtom } from "../model/state";

export type NecklineDividerProps = {
  /** X-coordinate of the center (already scaled) */
  centerX: number;
  /** Y-coordinate of the divider top (already scaled) */
  top: number;
  /** Height of the vertical divider (already scaled) */
  height: number;
  /** Half of the horizontal divider width (already scaled) */
  halfWidth: number;
  /** Total width of the horizontal divider (already scaled) */
  horizontalWidth: number;
  /** Stroke color for the divider lines */
  strokeColor: string;
};

export function NecklineDivider({
  centerX,
  top,
  height,
  halfWidth,
  horizontalWidth,
  strokeColor
}: NecklineDividerProps) {
  const zoom = useAtomValue(zoomAtom);
  return (
    <Group>
      {/* Top horizontal divider */}
      <Line
        x={centerX - halfWidth}
        y={top}
        points={[0, 0, horizontalWidth, 0]}
        stroke={strokeColor}
        strokeWidth={2 / zoom}
      />
      {/* Vertical divider */}
      <Line
        x={centerX}
        y={top}
        points={[0, 0, 0, height]}
        stroke={strokeColor}
        strokeWidth={2 / zoom}
      />
      {/* Bottom horizontal divider */}
      <Line
        x={centerX - halfWidth}
        y={top + height}
        points={[0, 0, horizontalWidth, 0]}
        stroke={strokeColor}
        strokeWidth={2 / zoom}
      />
    </Group>
  );
}
